<template>
  <div class="markPage">
    <Header></Header>

    <div class="bannerWrap">
      <div class="mainTit">
        <span class="active">应用市场</span>
      </div>
      <div class="sunTit">
        / Application market
      </div>
    </div>
     <div class="content">
       <div class="container">
         <div class="leftMenu">
           <div class="menuItem" :class="{ 'menuItemActive': id === item.id}" v-for="(item, idx) in tabsList" :key="idx" @click="handleClick(item)">
             {{item.name}}
             <span class="arrow" v-if="id === item.id">➞</span>
           </div>
         </div>
         <div class="rightContent">
           <template v-if="tabsData.length">
             <div class="cItem" v-for="(item, idx) in tabsData" :key="idx">
              <div class="cItemTit">
                <img class="icon" src="../../assets/images/yy@2x.png" />
                <span class="tit">{{item.title}}</span>
                <span class="num">已服务客户{{item.num}}</span>
              </div>
              <div class="cItemText">
                {{item.describe}}
              </div>
              <div class="myBtn" @click="goYYDetail(item.id)">查看应用详情 ➞</div>
            </div>
           </template>
           <template v-else>
             <div class="noData">
               <img src="../../assets/images/zwsj@2x.png" />
               <div>暂无数据</div>
             </div>
           </template>


         </div>
       </div>
     </div>
    <!--页脚-->
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    fetchAllCategory,
    fetchAllAppByFL,
  } from '@/api/api'
  export default {
    data() {
      return {
        baseUrl: serverUrl.baseURL,
        tabsList: [],
        tabsData: [],


        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
      }
    },
    components: {
      Header,
      Footer,
    },
    created() {
      fetchAllCategory().then(res => {
        this.tabsList = [{ name: '全部', id:'all'},...res.data]
        this.id = 'all'
        this.getTabsData()
      })
    },
    methods: {
      handleClick(item) {
        this.id = item.id
        this.getTabsData()
      },
      goYYDetail(id) {
        this.$router.push({
          path: "/marketdetails",
          query: {
            data: id
          },
        })
      },
      getTabsData() {
        let params = {
          page: this.pageNum-1,
          size: 999
        }
        if(this.id!=='all') {
          params.type = this.id
        }
        fetchAllAppByFL(params).then(res => {
          this.tabsData = res.data.content
          this.total = parseInt(res.data.totalElements)
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTabsData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getTabsData()
      },
    }
  }
</script>

<style scoped>
.markPage{
  background: rgba(249, 249, 249, 1);
}
.container{
  width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 77px;
  margin-bottom: 45px;
}
.leftMenu{
  width: 270px;
  min-height: 1000px;
  background: #FFFFFF;
  margin-right: 20px;
  box-sizing: border-box;
}
.menuItem{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.menuItemActive {
  background: linear-gradient(90deg, #0F5EFF, rgba(20,137,246,0.6));
  color: #fff;
}
.rightContent{
  background: #fff;
  flex: 1;
  padding: 20px;
  min-height: 1000px;
  box-sizing: border-box;
}

 .cItem{
  border-bottom: 1px dashed rgba(218, 223, 231, 1);
  padding: 20px 0;
  position: relative;
}
.cItemTit{
  margin-bottom: 24px;
}
.cItemTit .icon{
  width: 30px;
  height: 30px;
  vertical-align: middle;
}
.cItemTit .tit{
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  padding: 0 12px;
  vertical-align: middle;
}
.cItemTit .num{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #0F5EFF;
  background: #EDF2FF;
  border-radius: 4px;
  padding: 6px 10px;
  vertical-align: middle;
}
.cItemText{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #516381;
  line-height: 24px;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
}
.noData{
  width: 100%;
  height: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.noData img{
  width: 211px;
  height: 180px;
  margin-bottom: 20px;
}
.noData{
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #A8ADB9;
}
/*.cItemTit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #121E30;
  padding-bottom: 20px;
}
.cLeft{
  width: 80%;
}
.cItemText{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #516381;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}
.pageBox{
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
}*/
.myBtn{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #0F5EFF;
  padding: 7px 15px;
  border: 2px solid #0F5EFF;
  border-radius: 25px;
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 40px;
}
.bannerWrap{
  width: 100%;
  height: 480px;
  background: url('../../assets/images/yysc_BJ@2x.png') top center no-repeat;
  background-size: 100% 100%;
  padding: 265px 0 0 60px;
  box-sizing: border-box;
}
.mainTit{
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #346392;
  margin-bottom: 44px;
  cursor: pointer;
}
.mainTit span.active{
  color: #fff;
}
.sunTit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
}
.arrow{
  position: absolute;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/market/AppList.vue